// API_DOMAIN 网页接口域名，本地开发时使用vue.config.js配置的代理转发
// UPLOAD_DOMAIN 图片上传地址域名，本地开发时使用vue.config.js配置的代理转发
// PREVIEW_DOMAIN  图片上传之后，图片访问地址域名，本地开发时使用vue.config.js配置的代理转发
// LOG_DOMAIN 日志上报域名
// WEB_DOMAIN 网页访问域名
// STEAMF_BOX_DL 乐速盒子下载页面地址
// PUBG_INDEX PUBG社区首页地址前缀
// PUBG_GAME_ID 游戏社区用的
// CSGO2_GAME_ID CSGO2游戏id，fps准星用的
// VALORANT_GAME_ID 无畏锲约游戏id，fps准星用的
// GAME_SIGHT_LIST 游戏准星，游戏列表
// PING_VALUE 启动steam客户端ping检测，测试环境写小一点，方便测试
// DOWN_DOMAIN mod文件下载链接前缀
// CHECK_VIP_TIME_CEIL 检查会员信息，在游戏的过程中，单位是分钟
// DETAIL_PAGE_TO_SHOP_CHANNEL 商品详情页配置的商品跳转到商品默认渠道号

let API_DOMAIN = '/box_website'
let UPLOAD_DOMAIN = '/uploadImg'
let PREVIEW_DOMAIN = '/previewImg'
let LOG_DOMAIN = 'https://testlogs.steamf.cn'
let WEB_DOMAIN = 'https://testwww.steamf.cn'
let STEAMF_BOX_DL = 'https://testwww.steamf.cn/steamfbox.html'
let PUBG_INDEX = ''
let PUBG_GAME_ID = 5276638
let ONE_LEVEL_ID = 47 // 一级分类id
let USER_AGREEMENT_TOW_LEVEL_ID = 112 // 用户注册服务协议 二级分类id
let PRIVACY_POLICY_TOW_LEVEL_ID = 113 // 用户隐私政策 二级分类id
let PAY_AGREEMENT_TOW_LEVEL_ID = 111 // 付费服务协议 二级分类id
let OFF_ACCOUNT_LINK_TOW_LEVEL_ID = 114 // 注销协议 二级分类id
let CSGO2_GAME_ID = 5276426
let VALORANT_GAME_ID = 13235
let GAME_SIGHT_LIST = [
    { g_id: 5276426, name: 'CSGO2' },
    { g_id: 13235, name: 'Valorant' }
]
let PING_VALUE = 60
let DOWN_DOMAIN = 'https://testoss.steamf.cn/steamf/'
let CHECK_VIP_TIME_CEIL = 1
let WEIXIN_LOGIN_DOMAIN = 'https://www.steamf.cn'
let DETAIL_PAGE_TO_SHOP_CHANNEL = 1
let BOX_WEBSITE_DOMAIN = 'https://testbox.steamf.cn'

// steam图片地址、后加appid/hashValue.jpg
// let STEAM_IMG_PATH = "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/apps/"

// 游戏封面图 后加 appid/header.jpg
let STEAM_IMG_PATH = 'https://cdn.akamai.steamstatic.com/steam/apps/'

const NODE_ENV = process.env.NODE_ENV,
    VUE_APP_MODE = process.env.VUE_APP_MODE
if (NODE_ENV === 'development') {
    // 开发环境使用代理转发
    API_DOMAIN = '/box_website'
    UPLOAD_DOMAIN = '/uploadImg'
    PREVIEW_DOMAIN = '/previewImg'
    LOG_DOMAIN = 'https://testlogs.steamf.cn'
    WEB_DOMAIN = 'https://testwww.steamf.cn'
    STEAMF_BOX_DL = 'https://testwww.steamf.cn/steamfbox.html'
    PUBG_INDEX = ''
    PUBG_GAME_ID = 5276638
    CSGO2_GAME_ID = 5276426
    VALORANT_GAME_ID = 13235
    GAME_SIGHT_LIST = [
        { g_id: 5276426, name: 'CSGO2' },
        { g_id: 13235, name: 'Valorant' }
    ]
    PING_VALUE = 60
    DOWN_DOMAIN = 'https://testoss.steamf.cn/steamf/'
    CHECK_VIP_TIME_CEIL = 1
    WEIXIN_LOGIN_DOMAIN = 'https://www.steamf.cn'
    DETAIL_PAGE_TO_SHOP_CHANNEL = 1
    // 游戏封面图 后加 appid/header.jpg
    STEAM_IMG_PATH = 'https://cdn.akamai.steamstatic.com/steam/apps/'
    BOX_WEBSITE_DOMAIN = 'https://testbox.steamf.cn'
    ONE_LEVEL_ID = 47
    USER_AGREEMENT_TOW_LEVEL_ID = 112
    PRIVACY_POLICY_TOW_LEVEL_ID = 113
    PAY_AGREEMENT_TOW_LEVEL_ID = 111
    OFF_ACCOUNT_LINK_TOW_LEVEL_ID = 114
} else {
    switch (VUE_APP_MODE) {
        case 'test':
            API_DOMAIN = 'https://testapi.steamf.cn'
            UPLOAD_DOMAIN = 'https://testupload.steamf.cn/index.php?sign=388536b12ff1dcef004ddfde6e360c13&cfg=1&uid=0'
            PREVIEW_DOMAIN = 'https://testimg.steamf.cn'
            LOG_DOMAIN = 'https://testlogs.steamf.cn'
            WEB_DOMAIN = 'https://testwww.steamf.cn'
            STEAMF_BOX_DL = 'https://testwww.steamf.cn/steamfbox.html'
            PUBG_INDEX = WEB_DOMAIN
            PUBG_GAME_ID = 5276638
            CSGO2_GAME_ID = 5276426
            VALORANT_GAME_ID = 13235
            PING_VALUE = 60
            DOWN_DOMAIN = 'https://testoss.steamf.cn/steamf/'
            CHECK_VIP_TIME_CEIL = 1
            GAME_SIGHT_LIST = [
                { g_id: 5276426, name: 'CSGO2' },
                { g_id: 13235, name: 'Valorant' }
            ]
            DETAIL_PAGE_TO_SHOP_CHANNEL = 1
            BOX_WEBSITE_DOMAIN = 'https://testbox.steamf.cn'
            ONE_LEVEL_ID = 47
            USER_AGREEMENT_TOW_LEVEL_ID = 112
            PRIVACY_POLICY_TOW_LEVEL_ID = 113
            PAY_AGREEMENT_TOW_LEVEL_ID = 111
            OFF_ACCOUNT_LINK_TOW_LEVEL_ID = 114
            break
        case 'beta':
            API_DOMAIN = 'https://betaapi.steamf.cn'
            UPLOAD_DOMAIN = 'https://upload.steamf.cn/index.php?sign=388536b12ff1dcef004ddfde6e360c13&cfg=1&uid=0'
            PREVIEW_DOMAIN = 'https://img.steamf.cn'
            LOG_DOMAIN = 'https://logs.steamf.cn'
            WEB_DOMAIN = 'https://betawww.steamf.cn'
            STEAMF_BOX_DL = 'https://betawww.steamf.cn/steamfbox.html'
            PUBG_INDEX = WEB_DOMAIN
            PUBG_GAME_ID = 3
            CSGO2_GAME_ID = 122
            VALORANT_GAME_ID = 303
            PING_VALUE = 200
            CHECK_VIP_TIME_CEIL = 5
            DOWN_DOMAIN = 'https://oss.steamf.cn/steamf/'
            GAME_SIGHT_LIST = [
                { g_id: 122, name: 'CSGO2' },
                { g_id: 303, name: 'Valorant' }
            ]
            DETAIL_PAGE_TO_SHOP_CHANNEL = 70
            BOX_WEBSITE_DOMAIN = 'https://betabox.steamf.cn'
            ONE_LEVEL_ID = 39
            USER_AGREEMENT_TOW_LEVEL_ID = 113
            PRIVACY_POLICY_TOW_LEVEL_ID = 112
            PAY_AGREEMENT_TOW_LEVEL_ID = 114
            OFF_ACCOUNT_LINK_TOW_LEVEL_ID = 115
            break
        case 'line':
            API_DOMAIN = 'https://api.steamf.cn'
            UPLOAD_DOMAIN = 'https://upload.steamf.cn/index.php?sign=388536b12ff1dcef004ddfde6e360c13&cfg=1&uid=0'
            PREVIEW_DOMAIN = 'https://img.steamf.cn'
            LOG_DOMAIN = 'https://logs.steamf.cn'
            WEB_DOMAIN = 'https://www.steamf.cn'
            STEAMF_BOX_DL = 'https://www.steamf.cn/steamfbox.html'
            PUBG_INDEX = WEB_DOMAIN
            PUBG_GAME_ID = 3
            CSGO2_GAME_ID = 122
            VALORANT_GAME_ID = 303
            PING_VALUE = 200
            CHECK_VIP_TIME_CEIL = 5
            DOWN_DOMAIN = 'https://oss.steamf.cn/steamf/'
            GAME_SIGHT_LIST = [
                { g_id: 122, name: 'CSGO2' },
                { g_id: 303, name: 'Valorant' }
            ]
            DETAIL_PAGE_TO_SHOP_CHANNEL = 70
            BOX_WEBSITE_DOMAIN = 'https://box.steamf.cn'
            ONE_LEVEL_ID = 39
            USER_AGREEMENT_TOW_LEVEL_ID = 113
            PRIVACY_POLICY_TOW_LEVEL_ID = 112
            PAY_AGREEMENT_TOW_LEVEL_ID = 114
            OFF_ACCOUNT_LINK_TOW_LEVEL_ID = 115
            break
    }
}

export default {
    API_DOMAIN,
    UPLOAD_DOMAIN,
    PREVIEW_DOMAIN,
    LOG_DOMAIN,
    WEB_DOMAIN,
    STEAMF_BOX_DL,
    PUBG_INDEX,
    PUBG_GAME_ID,
    PING_VALUE,
    DOWN_DOMAIN,
    CHECK_VIP_TIME_CEIL,
    GAME_SIGHT_LIST,
    CSGO2_GAME_ID,
    VALORANT_GAME_ID,
    WEIXIN_LOGIN_DOMAIN,
    DETAIL_PAGE_TO_SHOP_CHANNEL,
    STEAM_IMG_PATH,
    BOX_WEBSITE_DOMAIN,
    ONE_LEVEL_ID,
    USER_AGREEMENT_TOW_LEVEL_ID,
    PRIVACY_POLICY_TOW_LEVEL_ID,
    PAY_AGREEMENT_TOW_LEVEL_ID,
    OFF_ACCOUNT_LINK_TOW_LEVEL_ID
}
